import { render, staticRenderFns } from "./dj-study.vue?vue&type=template&id=4f3f1b5c&scoped=true"
import script from "./dj-study.vue?vue&type=script&lang=js"
export * from "./dj-study.vue?vue&type=script&lang=js"
import style0 from "./dj-study.vue?vue&type=style&index=0&id=4f3f1b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f1b5c",
  null
  
)

export default component.exports